import { Component } from '@angular/core';
import {TableComponent} from "../../../../shared/components/table/table.component";

@Component({
  selector: 'app-canceled-event-list',
  standalone: true,
    imports: [
        TableComponent
    ],
  templateUrl: './canceled-event-list.component.html',
  styleUrl: './canceled-event-list.component.scss'
})
export class CanceledEventListComponent {
  configurationTable: any = {
    "columns": [
      {
        "id": "service_events.id",
        "title": "Evento",
        "type": "text",
        "placeholder": "",
        "required": false,
        "hide": true
      },
      {
        "id": "service_events.service_id",
        "title": "Orden de Servicio",
        "type": "select",
        "placeholder": "",
        "serviceConfig": {
          "table": "listService",
          "idColumn": "id",
          "valueColumn": "ruta"
        },
        "required": false,
        "hide": true
      },
      {
        "id": "service_events.event_date",
        "title": "Fecha",
        "type": "date",
        "placeholder": "",
        "required": false,
        "hide": true
      },
      {
        "id": "typeService.configurableListsCode",
        "title": "Tipo Evento",
        "type": "select",
        "placeholder": "",
        "serviceConfig": {
          "table": "listConfigurableEvent",
          "idColumn": "idconfigurableLists",
          "valueColumn": "configurableListsCode",
          "conditionColumn":"configurableListsField",
          "conditionValue":"Motivo del evento"
        },
        "required": false,
        "hide": true
      },
      {
        "id": "reason.configurableListsCode",
        "title": "Motivo",
        "type": "select",
        "placeholder": "",
        "serviceConfig": {
          "table": "listConfigurableEvent",
          "idColumn": "idconfigurableLists",
          "valueColumn": "configurableListsCode",
          "conditionColumn":"configurableListsField",
          "conditionValue":"Tipo Evento"
        },
        "required": false,
        "hide": true
      },
      {
        "id": "service_events.event_description",
        "title": "Descripción",
        "type": "text",
        "placeholder": "",
        "required": false,
        "hide": true
      },
      {
        "id": "service_events.amount",
        "title": "Monto",
        "type": "text",
        "placeholder": "",
        "required": false,
        "hide": false
      },
      {
        "id": "service_events.assigned",
        "title": "Asignado a",
        "type": "select",
        "placeholder": "",
        "serviceConfig": {
          "table": "asignedTo",
        },
        "required": false,
        "hide": true
      },
      {
        "id": "service_events.deductible",
        "title": "Deducible",
        "type": "select",
        "placeholder": "",
        "serviceConfig": {
          "table": "deductible",
        },
        "required": false,
        "hide": true
      },
      {
        "id": "service_events.reason_cancellation",
        "title": "Motivo de cancelación",
        "type": "text",
        "placeholder": "",
        "required": false,
        "hide": true,
      },
      {
        "id": "service_events.updated_date",
        "title": "Fecha de cancelación",
        "type": "date",
        "placeholder": "",
        "required": false,
        "hide": true
      },
      {
        "btnName": "Opciones",
        "actions": [
          {
            "btnName": "Ver evidencias",
            "textConfirmation": "",
            "action": {
              "type": "emmit",
              "fn": this.newEvent.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-primary border border-primary',
              "icons": 'plus'
            }
          },
        ]
      }
    ],
    "config": "canceledServiceEvents",
    "sortColumn": "service_events.event_date",
    "sortDirection": "ASC",
    "title": "Eventos cancelados",
    "filterPrincipal": [
    ],
    "filters":[]
  }

  newEvent(){}
}
